import { Button } from "@mui/material"

const OutlinedButton = ({width,text,onClick,id}) => {
  return (
    <Button variant="outlined" className="outlined_btn" style={{width}} id={id} onClick={onClick}>{text}</Button>
  )
}

export default OutlinedButton